import React, { useEffect, useState } from "react";
import VendorHeader from "../../CustomComponents/Property/VendorHeader/VendorHeader";
import SideBar from "../../CustomComponents/Property/SideBar/SideBar";
import AllRooms from "../../CustomComponents/Property/AllRooms/AllRooms";
import ManageRatesPlans from "../../CustomComponents/Property/AllRooms/ManageRatesPlans";

function ManageRatesPlansPage({ allPropertiesPage }) {
  return (
    <>
      {/* <div className="sidebar_main_div new_sidebar_main_div">
        <SideBar allPropertiesPage={false} />
        <div className="agent-info-container">
          <VendorHeader showSelectProperty={true} vendorProperty={false} /> */}
          <ManageRatesPlans />
        {/* </div>
      </div> */}
    </>
  );
}

export default ManageRatesPlansPage;
